import {mapState} from 'vuex';

export const mobileAppMapStateMixin = {
	computed: {
		...mapState([
			'isWebApp',
			'isMobileApp',
			'isAndroidApp',
			'isIOSApp',
			'isIPadOSApp',
			'isIPhoneApp',
			'isIPadApp',
			'MobileApp',
		]),
	},
}
